import React, { Component } from 'react';
import DrawerSlideWrapper from './DrawerSlideWrapper';
import DrawerHeader from './DrawerHeader';
import MenuSelectionCard from './MenuSelectionCardNew';
import Formsy from 'formsy-react';
import FormsyInputMui from '../form/FormsyInputMui';
import FormRadio from '../form/Radio';
import Div100vh from 'react-div-100vh';
import isEqual from 'lodash.isequal';

const portionSwitch = portion =>
  ({
    small: 1,
    medium: 2,
    large: 3
  }[portion]);

const notesCharLimit = 250;

class CustomizeDish extends Component {
  state = {
    menuSelection: {
      notes: '',
      portion: ''
    },
    isUpdated: false
  };

  portionOptions = [
    { value: '1.0', label: 'Small' },
    { value: '2.0', label: 'Medium' },
    { value: '3.0', label: 'Large' }
  ];

  render() {
    const {
      handleClose,
      isOpen,
      favoritedDishes,
      favoriteDish,
      unfavoriteDish
    } = this.props;
    const { menuSelection, isUpdated } = this.state;
    const { dish, notes, portion } = menuSelection;

    return (
      <DrawerSlideWrapper isOpen={isOpen} isLeft={true}>
        <Div100vh>
          <DrawerHeader title="Dish Customization" handleClose={handleClose} />
          <div className="customize-dish">
            <MenuSelectionCard
              dish={dish}
              className="customize-dish__dish-info"
              displayOnly={true}
              favoritedDishes={favoritedDishes}
              favoriteDish={favoriteDish}
              unfavoriteDish={unfavoriteDish}
            />
            <hr className="customize-dish__hr"></hr>

            <Formsy className="new-form" onValidSubmit={this.handleSubmit}>
              <div className="customize-dish__portion-section">
                <FormRadio
                  className="radio--blue radio--large radio--horizontal"
                  name="portion"
                  placeholder=""
                  options={this.portionOptions}
                  value={portion || ''}
                  onChange={this.handleChange}
                />
              </div>
              <div className="customize-dish__notes-section">
                <FormsyInputMui
                  title="Customization Notes"
                  type="text"
                  name="notes"
                  value={notes}
                  onChange={this.handleChange}
                  multiline
                  rowsMax="10"
                  placeholder="I want to..."
                />
              </div>

              <input
                type="submit"
                className="new-btn new-btn--solid-green new-btn--full-width customize-dish__submit"
                value="Customize"
                disabled={!isUpdated}
              />
            </Formsy>
          </div>
        </Div100vh>
      </DrawerSlideWrapper>
    );
  }

  getPortionFromProps = () => {
    const { portion } = this.props.menuSelection;
    const { portion_size } = this.props.client;

    // selection portion will default to client's portion_size
    return portion ? portion : `${portionSwitch(portion_size)}.0`; // format numbers as string with decimal.  e.g. "1.0"
  };

  handleChange = e => {
    let { menuSelection } = this.state;
    const { name, value } = e.target;

    if (value.length <= notesCharLimit) {
      menuSelection = {
        ...menuSelection,
        [name]: value
      };

      const portion = this.getPortionFromProps();

      // check to see if field(s) have been changed
      const isUpdated = !isEqual(menuSelection, {
        ...this.props.menuSelection,
        portion
      });

      this.setState({
        menuSelection,
        isUpdated
      });
    }
  };

  handleSubmit = () => {
    const { handleCustomizeSubmit, index } = this.props;
    const { menuSelection } = this.state;

    handleCustomizeSubmit(index, menuSelection);
  };

  componentDidUpdate(prevProps) {
    const { menuSelection } = this.props;
    const portion = this.getPortionFromProps();

    if (prevProps.menuSelection !== menuSelection) {
      this.setState({
        menuSelection: {
          ...menuSelection,
          portion
        },
        isUpdated: false
      });
    }
  }

  componentDidMount() {
    const { menuSelection = {} } = this.props;

    this.setState({ menuSelection });
  }
}

export default CustomizeDish;



// WEBPACK FOOTER //
// ./src/components/new/CustomizeDish.js